import { Fragment, useMemo } from "react";

import { BlankContentForList } from "@/components/features/_components";

import { Table, TableBody } from "@/components/ui/table/table";

import { GuestListTableTBody } from "./t-body";
import { GuestListTableTHead } from "./t-head";
import { UpdateMemoForOptionPms } from "../../../update-memo-for-option-pms";

import type * as Model from "../../model";

type Props = {
	viewData: Model.Type.ViewData;
	// 行の選択
	onSelectRow: (cardID?: string) => void;
	// 行の選択解除
	onUnSelectRow: () => void;
	// オプションのキャンセル
	onCancelOptionPmsItem: ({
		cardID,
		optionID,
		date,
		subOptionID,
	}: {
		cardID: string;
		optionID: string;
		date: string;
		subOptionID?: string;
	}) => Promise<void>;
};

export const GuestListTable = ({ viewData, onSelectRow, onUnSelectRow, onCancelOptionPmsItem }: Props) => {
	/**
	 * 行データ
	 */
	const rowDataList = useMemo(() => viewData.rowDataList, [viewData.rowDataList]);

	/**
	 * 行データの表示制御
	 */
	const canShowRows = useMemo(() => viewData.hasRowDataList, [viewData.hasRowDataList]);

	return (
		<>
			{canShowRows ? (
				<Table id="search-result-table" className="min-w-[max-content]">
					{/* ヘッダー */}
					<GuestListTableTHead />

					{/* 行 */}
					<TableBody>
						<>
							{rowDataList.map((row, index) => {
								return (
									<Fragment key={index}>
										<GuestListTableTBody
											row={row}
											onUpdateOptionPms={onSelectRow}
											onCancelOptionPmsItem={onCancelOptionPmsItem}
										/>

										{viewData.selectedOption?.cardID === row.cardID ? (
											<UpdateMemoForOptionPms
												option={row.option}
												onCloseCallback={onUnSelectRow}
											/>
										) : null}
									</Fragment>
								);
							})}
						</>
					</TableBody>
				</Table>
			) : (
				<BlankContentForList content={`該当のデータがありません。\n条件を変更して検索してください。`} />
			)}
		</>
	);
};
